export const PaymentTypeClient = Object.freeze({
  PRIVATE: '44',
});

export const PaymentTypeClientId = Object.freeze({
  44: 'private',
});

export const HealthInsuranceClientId = Object.freeze({
  AMIL: '80',
  DASAFUNC: '5775',
  BRADESCO: '67',
});
